import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctBytes32 } from '../../../../Fct/generics';
import { supportedContracts } from '../constants';
export var EqualBytes32 = createPlugin({
    protocol: 'TOKEN_VALIDATOR',
    type: 'VALIDATOR',
    method: 'equalBytes32',
    description: 'Check if amount1 is equal amount2',
    supportedContracts: supportedContracts,
    getParams: function () { return ({
        input: {
            to: new FctAddress({}),
            methodParams: {
                value1: new FctBytes32({}),
                value2: new FctBytes32({}),
            },
        },
        output: {
            value1: new FctBytes32({
                innerIndex: 0,
            }),
        },
    }); },
});
